module.exports = __webpack_public_path__ + "static/media/js.b4d1e734.png";